import { NotificationColorKey, NotificationIconKey } from "@upsquad/shared";
import {
	AtSign,
	Bell,
	Calendar,
	CalendarX,
	Clock,
	Heart,
	type LucideIcon,
	MessageCircle,
	Shield,
	ShieldAlert,
	UserCheck,
	UserMinus,
	UserPlus,
	UserX,
} from "lucide-react";

export const NOTIFICATION_ICONS: Record<NotificationIconKey, LucideIcon> = {
	[NotificationIconKey.AT_SIGN]: AtSign,
	[NotificationIconKey.BELL]: Bell,
	[NotificationIconKey.CALENDAR]: Calendar,
	[NotificationIconKey.CALENDAR_X]: CalendarX,
	[NotificationIconKey.CLOCK]: Clock,
	[NotificationIconKey.HEART]: Heart,
	[NotificationIconKey.MESSAGE_CIRCLE]: MessageCircle,
	[NotificationIconKey.SHIELD]: Shield,
	[NotificationIconKey.SHIELD_ALERT]: ShieldAlert,
	[NotificationIconKey.USER_CHECK]: UserCheck,
	[NotificationIconKey.USER_MINUS]: UserMinus,
	[NotificationIconKey.USER_PLUS]: UserPlus,
	[NotificationIconKey.USER_X]: UserX,
};

export const NOTIFICATION_COLOR_CLASSES: Record<NotificationColorKey, string> = {
	[NotificationColorKey.DANGER]: "text-danger",
	[NotificationColorKey.PRIMARY]: "text-primary",
	[NotificationColorKey.SECONDARY]: "text-secondary",
	[NotificationColorKey.WARNING]: "text-warning",
	[NotificationColorKey.SUCCESS]: "text-success",
	[NotificationColorKey.MUTED]: "text-foreground/50",
};
